export default __webpack_public_path__ + "static/media/belize.c0076d9b.jpg";